import '@/legacy/shared/blank-links';
import { initSberWidget } from '@helpers/sber-widget';
import '@/helpers/hide-on-error';
import '@/legacy/shared/amo-chat-collapse';

/**
 * Load PDP / brands legacy helpers only when their DOM markers exist.
 * Call inits directly (do not rely on DOMContentLoaded inside dynamic chunks —
 * that event may already have fired).
 */
async function bootConditionalLegacy(): Promise<void> {
  const tasks: Promise<unknown>[] = [];

  if (document.querySelector('.shop-tabs')) {
    tasks.push(import('@helpers/shop-tabs').then(({ initShopTabs }) => initShopTabs()));
  }

  if (
    document.getElementById('show-more-title') ||
    document.getElementById('product-title__main') ||
    document.querySelector('.part-suggestions-table__table-cell-name')
  ) {
    tasks.push(
      import('@helpers/show-more-button').then(({ initShowMoreButton }) => initShowMoreButton())
    );
  }

  if (document.getElementById('part-suggestions-table-wrapper')) {
    tasks.push(
      import('@helpers/part-suggestion-table').then(({ initPartSuggestionTableScroll }) =>
        initPartSuggestionTableScroll()
      )
    );
  }

  if (
    document.querySelector('#part-suggestion-anchor') ||
    document.querySelector('.part-suggest-link') ||
    document.querySelector('[data-scroll-to-anchor]')
  ) {
    tasks.push(
      import('@helpers/part-page-anchors').then(({ initPartPageAnchors }) => initPartPageAnchors())
    );
  }

  if (document.querySelector('.all-brands__anchor-link_lang')) {
    tasks.push(
      import('@helpers/brands-lang-switcher').then(({ initBrandsLangSwitcher }) =>
        initBrandsLangSwitcher()
      )
    );
  }

  await Promise.all(tasks);
}

function whenDomReady(fn: () => void): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}

whenDomReady(() => {
  void bootConditionalLegacy();
});

initSberWidget({ delayMs: 10000 });
